<div class="app-container wizard-container">
  @if (showSuccessScreen) {
    <app-success-screen (newReport)="onBackFromSuccess()">
    </app-success-screen>
  }
  @if (!isSubmitted && !showSuccessScreen) {
  <mat-card class="wizard-card">
    <div class="wizard-header-sticky">
      <mat-card-header>
        <div class="header-content">
          <div class="title-section">
            <mat-card-title>{{ 'page.title' | translate }}</mat-card-title>
          </div>
        </div>
      </mat-card-header>
      @if (isFlowSelected) {
      <div class="wizard-progress">
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="getProgressPercentage()"></div>
        </div>
        <div class="progress-text">
          {{ 'wizard.progress' | translate }}: {{ getCompletedSteps() }}/{{ getTotalSteps() }} {{
          'wizard.steps.completed' | translate }}
        </div>
      </div>
      }
    </div>

    <mat-card-content>
      <!-- Custom accordion usando mat-expansion-panel -->
      <mat-accordion>
        <!-- Step 0: Language Selection -->
        <mat-expansion-panel class="language-panel" [expanded]="true" [disabled]="false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>language</mat-icon> &nbsp;
                Language
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="language-selection">
            <h3>{{ 'language.select' | translate }}</h3>
            <app-language-selector></app-language-selector>
          </div>
        </mat-expansion-panel>

        <!-- Step 0.5: Initial Options -->
        <mat-expansion-panel class="initial-options-panel" [expanded]="canEnterInitialOptions()" [disabled]="!canEnterInitialOptions()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon [color]="isFlowSelected ? 'primary' : 'language'">
                {{ isFlowSelected ? 'check_circle' : 'route' }}
              </mat-icon> &nbsp;
              {{ 'initialOptions.title' | translate }}
              @if (!canEnterInitialOptions()) {
                <mat-icon color="warn" style="margin-left: 10px;">lock</mat-icon>
              }
            </mat-panel-title>
            @if (!canEnterInitialOptions()) {
              <mat-panel-description>
                <span>{{ 'wizard.locked.language' | translate }}</span>
              </mat-panel-description>
            }
          </mat-expansion-panel-header>
          @if (canEnterInitialOptions()) {
          <div class="initial-options">
            <div class="initial-options-grid">
              <button type="button"
                      mat-button
                      class="initial-option-card"
                      [class.initial-option-card--selected]="isFlowSelected && isFullFlow()"
                      [class.initial-option-card--inactive]="isFlowSelected && !isFullFlow()"
                      (click)="onClaimFlowSelected('full')">
                @if (isFlowSelected && isFullFlow()) {
                  <mat-icon class="initial-option-check">check_circle</mat-icon>
                }
                <div class="initial-option-icon-wrap">
                  <mat-icon class="initial-option-icon">edit_note</mat-icon>
                </div>
                <span class="initial-option-title">{{ 'initialOptions.fullFlow.title' | translate }}</span>
                <!-- <div class="initial-option-description">{{ 'initialOptions.fullFlow.description' | translate }}</div> -->
              </button>
              <button type="button"
                      mat-button
                      class="initial-option-card"
                      [class.initial-option-card--selected]="isFlowSelected && isCidUploadFlow()"
                      [class.initial-option-card--inactive]="isFlowSelected && !isCidUploadFlow()"
                      (click)="onClaimFlowSelected('cid-upload')">
                @if (isFlowSelected && isCidUploadFlow()) {
                  <mat-icon class="initial-option-check">check_circle</mat-icon>
                }
                <div class="initial-option-icon-wrap">
                  <mat-icon class="initial-option-icon">upload_file</mat-icon>
                </div>
                <span class="initial-option-title">{{ 'initialOptions.cidUpload.title' | translate }}</span>
                <!-- <div class="initial-option-description">{{ 'initialOptions.cidUpload.description' | translate }}</div> -->
              </button>
            </div>
          </div>
          }
        </mat-expansion-panel>

        <!-- Step 1: Dati Autista e Veicolo -->
        @if (isFlowSelected) {
        <mat-expansion-panel [disabled]="!canEnterDriverVehicle()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon
                [color]="driverVehicleForm.valid ? 'primary' : (!canEnterDriverVehicle() ? 'disabled' : 'warn')">
                {{ driverVehicleForm.valid ? 'check_circle' : 'person' }}
              </mat-icon> &nbsp;
              {{ 'step1.driverVehicle' | translate }}
              @if (!canEnterDriverVehicle()) {
                <mat-icon color="warn" style="margin-left: 10px;">lock</mat-icon>
              }
            </mat-panel-title>
            @if (!canEnterDriverVehicle()) {
              <mat-panel-description>
                @if (!crashesInfoLoaded) {
                  <span>Caricamento dati veicolo in corso...</span>
                }
                @if (crashesInfoLoaded && !isLanguageSelected) {
                  <span>{{ 'wizard.locked.language' | translate }}</span>
                }
              </mat-panel-description>
            }
          </mat-expansion-panel-header>
          @if (canEnterDriverVehicle()) {
          <app-step-driver-vehicle-data [form]="driverVehicleForm" [preselectedTarga]="preselectedTarga" [vehicleInfo]="crashesInfoData?.vehicleInfo" [crashesInfoData]="crashesInfoData"></app-step-driver-vehicle-data>
          }
        </mat-expansion-panel>
        }

        @if (isCidUploadFlow()) {
        <!-- Step CID: Upload Modulo CID -->
        <mat-expansion-panel class="cid-upload-panel" [disabled]="!canEnterCidUpload()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon [color]="isCidUploadValid() ? 'primary' : (!canEnterCidUpload() ? 'disabled' : 'warn')">
                {{ isCidUploadValid() ? 'check_circle' : 'description' }}
              </mat-icon> &nbsp;
              {{ 'cidUpload.title' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (canEnterCidUpload()) {
          <div class="cid-upload-section">
            <p>{{ 'cidUpload.info' | translate }}</p>
            <div class="file-upload-section">
              <input type="file"
                     #cidDocInput
                     multiple
                     accept="image/*,application/pdf,.heic,.heif"
                     (change)="onCidDocumentSelected($event)"
                     style="display: none;">

              <button mat-raised-button
                      type="button"
                      color="primary"
                      (click)="cidDocInput.click()"
                      [disabled]="cidDocumentLoading">
                <mat-icon>attach_file</mat-icon>
                {{ 'cidUpload.select' | translate }}
              </button>

              @if (cidDocumentLoading) {
                <mat-spinner diameter="30" style="margin-left: 16px;"></mat-spinner>
              }
            </div>

            @if (getCidDocuments().length > 0) {
            <div class="photo-preview-grid">
              <h4>{{ 'cidUpload.preview' | translate }} ({{ getCidDocuments().length }})</h4>
              <div class="preview-grid">
                @for (doc of getCidDocuments(); track doc.name; let i = $index) {
                  <div class="preview-item">
                    @if (doc.isPdf && !doc.url) {
                      <div class="preview-pdf preview-pdf--clickable"
                           (click)="openCidDocumentPreview(doc)"
                           role="button"
                           tabindex="0"
                           [attr.aria-label]="'cidUpload.title' | translate"
                           (keydown.enter)="openCidDocumentPreview(doc)"
                           (keydown.space)="openCidDocumentPreview(doc); $event.preventDefault()">
                        <mat-icon>picture_as_pdf</mat-icon>
                      </div>
                    } @else {
                      <img [src]="doc.url"
                           (click)="openCidDocumentPreview(doc)"
                           class="preview-image"
                           [alt]="'cidUpload.title' | translate">
                    }
                    <button mat-icon-button
                            type="button"
                            (click)="removeCidDocument(i)"
                            class="remove-btn">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                }
              </div>
            </div>
            }

            @if (getCidDocuments().length > 0) {
            <div class="action-buttons-container">
              <button mat-raised-button
                      color="primary"
                      type="button"
                      class="action-btn submit-btn"
                      (click)="onSubmitCidUpload()"
                      [disabled]="isCidSubmitting || !canEnterCidSubmit()">
                <mat-icon>send</mat-icon>
                <span>{{ 'button.submitClaim' | translate }}</span>
              </button>
            </div>
            }
          </div>
          }
        </mat-expansion-panel>
        }

        @if (isFullFlow()) {
        <!-- Step 2: Dettagli Sinistro -->
        <mat-expansion-panel [disabled]="!canEnterDettagliSinistro()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon
                [color]="dettagliSinistroForm.valid ? 'primary' : (!canEnterDettagliSinistro() ? 'disabled' : 'warn')">
                {{ dettagliSinistroForm.valid ? 'check_circle' : 'report_problem' }}
              </mat-icon> &nbsp;
              {{ 'step-accident-details.label' | translate }}
              @if (isLoadingLocation) {
                <mat-spinner diameter="20" style="margin-left: 10px;"></mat-spinner>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (canEnterDettagliSinistro()) {
          <app-step-accident-details [form]="dettagliSinistroForm"
            [isLoadingLocation]="isLoadingLocation" [incidentLocation]="incidentLocation"
            [currentLocation]="currentLocation" [crashesInfoData]="crashesInfoData"
            (locationSelected)="onIncidentLocationSelected($event)"
            (currentLocationChanged)="onCurrentLocationSelected($event)">
          </app-step-accident-details>
          }
        </mat-expansion-panel>

        <!-- Step 3: Veicoli Coinvolti -->
        <mat-expansion-panel #involvedVehiclesPanel [disabled]="!canEnterInvolvedVehicles()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon [color]="isInvolvedVehiclesValid ? 'primary' : (!canEnterInvolvedVehicles() ? 'disabled' : 'warn')">
                {{ isInvolvedVehiclesValid ? 'check_circle' : 'directions_car' }}
              </mat-icon> &nbsp;
              {{ 'step-involved-vehicles.label' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (canEnterInvolvedVehicles()) {
          <app-step-involved-vehicles [form]="involvedVehiclesForm"></app-step-involved-vehicles>
          }
        </mat-expansion-panel>

        <!-- Step 4: Dinamica del Sinistro -->
        <mat-expansion-panel #dynamicsPanel class="dynamics-panel" [disabled]="!canEnterAccidentDynamics()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon [color]="isAccidentDynamicsValid ? 'primary' : (!canEnterAccidentDynamics() ? 'disabled' : 'warn')">
                {{ isAccidentDynamicsValid ? 'check_circle' : 'swap_horiz' }}
              </mat-icon> &nbsp;
              {{ 'step-accident-dynamics.label' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (canEnterAccidentDynamics()) {
          <app-step-accident-dynamics [form]="accidentDynamicsForm" [plate]="preselectedTarga" [involvedVehicles]="getInvolvedVehicles()"></app-step-accident-dynamics>
          }
        </mat-expansion-panel>

        <!-- Step 5: Danni e feriti -->
        <mat-expansion-panel [disabled]="!canEnterDanni()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon [color]="isDanniValid ? 'primary' : (!canEnterDanni() ? 'disabled' : 'warn')">
                {{ isDanniValid ? 'check_circle' : 'build' }}
              </mat-icon> &nbsp;
              {{ 'step-damage-injuries.label' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (canEnterDanni()) {
          <app-step-damage-description [form]="danniForm" [licensePlate]="preselectedTarga"></app-step-damage-description>
          }
        </mat-expansion-panel>

        <!-- Step 6: Foto -->
        <mat-expansion-panel class="photo-panel" [disabled]="!canEnterFoto()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon [color]="canEnterFoto() ? (getTotalPhotos() > 0 ? 'primary' : 'warn') : 'disabled'">
                {{ getTotalPhotos() > 0 && canEnterFoto() ? 'check_circle' : 'camera_alt' }}
              </mat-icon> &nbsp;
              {{ 'photo.title' | translate }} *
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (canEnterFoto()) {
          <div class="photo-section">
            <p>{{ 'photo.info' | translate }}</p>
            
            <!-- Sezione Veicolo A -->
            <mat-card class="vehicle-photo-card vehicle-a">
              <mat-card-header>
                <mat-card-title>
                  <mat-icon>directions_car</mat-icon>
                  {{ 'photo.vehicle.a' | translate }} ({{ preselectedTarga }})
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="file-upload-section">
                  <input type="file" 
                         #fileInputA 
                         multiple 
                         accept="image/*" 
                         (change)="onFileSelected($event, 'A')" 
                         style="display: none;">
                  
                  <button mat-raised-button 
                          color="primary" 
                          (click)="fileInputA.click()" 
                          [disabled]="isVehicleLoading('A')">
                    <mat-icon>add_photo_alternate</mat-icon>
                    {{ 'button.selectPhotos' | translate }}
                  </button>
                  
                  @if (isVehicleLoading('A')) {
                    <mat-spinner diameter="30" style="margin-left: 16px;"></mat-spinner>
                  }
                </div>
                @if (getVehiclePhotos('A').length > 0) {
                <div class="photo-preview-grid">
                  <h4>{{ 'photo.preview' | translate }} ({{ getVehiclePhotos('A').length }})</h4>
                  <div class="preview-grid">
                    @for (photo of getVehiclePhotos('A'); track $index; let i = $index) {
                      <div class="preview-item">
                        <img [src]="photo.url"
                             (click)="openImagePreview(photo.url)"
                             class="preview-image">
                        <button mat-icon-button
                                (click)="removeVehicleImage('A', i)"
                                class="remove-btn">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    }
                  </div>
                </div>
                }
              </mat-card-content>
            </mat-card>
            <!-- Sezioni veicoli coinvolti dinamiche -->
            @for (vehicle of getInvolvedVehicles(); track vehicle.plate; let i = $index) {
            <mat-card class="vehicle-photo-card"
                     [ngClass]="'vehicle-' + vehicleLetters[i + 1].toLowerCase()">
              <mat-card-header>
                <mat-card-title>
                  <mat-icon>local_shipping</mat-icon>
                  {{ 'photo.vehicle' | translate }} {{ vehicleLetters[i + 1] }} ({{ vehicle.plate }})
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="file-upload-section">
                  <input type="file" 
                         #fileInput
                         multiple 
                         accept="image/*" 
                         (change)="onFileSelected($event, vehicleLetters[i + 1])" 
                         style="display: none;">
                  
                  <button mat-raised-button 
                          [color]="i % 2 === 0 ? 'accent' : 'warn'" 
                          (click)="fileInput.click()" 
                          [disabled]="isVehicleLoading(vehicleLetters[i + 1])">
                    <mat-icon>add_photo_alternate</mat-icon>
                    {{ 'button.selectPhotos' | translate }}
                  </button>
                  
                  @if (isVehicleLoading(vehicleLetters[i + 1])) {
                    <mat-spinner diameter="30" style="margin-left: 16px;"></mat-spinner>
                  }
                </div>
                @if (getVehiclePhotos(vehicleLetters[i + 1]).length > 0) {
                <div class="photo-preview-grid">
                  <h4>{{ 'photo.preview' | translate }} ({{ getVehiclePhotos(vehicleLetters[i + 1]).length }})</h4>
                  <div class="preview-grid">
                    @for (photo of getVehiclePhotos(vehicleLetters[i + 1]); track $index; let j = $index) {
                      <div class="preview-item">
                        <img [src]="photo.url"
                             (click)="openImagePreview(photo.url)"
                             class="preview-image">
                        <button mat-icon-button
                                (click)="removeVehicleImage(vehicleLetters[i + 1], j)"
                                class="remove-btn">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    }
                  </div>
                </div>
                }
              </mat-card-content>
            </mat-card>
            }

            @if (hasWitnesses()) {
            <mat-card class="vehicle-photo-card vehicle-neutral">
              <mat-card-header>
                <mat-card-title>
                  <mat-icon>description</mat-icon>
                  {{ 'witnesses.document.title' | translate }}
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="file-upload-section">
                  <input type="file"
                         #witnessDocInput
                         multiple
                         accept="image/*"
                         (change)="onWitnessDocumentSelected($event)"
                         style="display: none;">

                  <button mat-raised-button
                          type="button"
                          (click)="witnessDocInput.click()"
                          [disabled]="witnessDocumentLoading">
                    <mat-icon>attach_file</mat-icon>
                    {{ 'witnesses.document.select' | translate }}
                  </button>

                  @if (witnessDocumentLoading) {
                    <mat-spinner diameter="30" style="margin-left: 16px;"></mat-spinner>
                  }
                </div>

                @if (getWitnessDocuments().length > 0) {
                <div class="photo-preview-grid">
                  <h4>{{ 'photo.preview' | translate }} ({{ getWitnessDocuments().length }})</h4>
                  <div class="preview-grid">
                    @for (doc of getWitnessDocuments(); track doc.name; let i = $index) {
                      <div class="preview-item">
                        <img [src]="doc.url"
                             (click)="openImagePreview(doc.url)"
                             class="preview-image"
                             [alt]="'witnesses.document.title' | translate">
                        <button mat-icon-button
                                type="button"
                                (click)="removeWitnessDocument(i)"
                                class="remove-btn">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    }
                  </div>
                </div>
                }
              </mat-card-content>
            </mat-card>
            }
          </div>
          }
        </mat-expansion-panel>

        <!-- Step 6: Riepilogo -->
        <mat-expansion-panel [disabled]="!canEnterRiepilogo()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon [color]="canEnterRiepilogo() ? 'primary' : 'disabled'">
                {{ canEnterRiepilogo() ? 'check_circle' : 'summarize' }}
              </mat-icon> &nbsp;
              {{ 'summary.title' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (canEnterRiepilogo()) {
          <app-step-summary
            [form]="fotoForm" 
            [summaryData]="getSummary()" 
            [accidentDynamicsData]="accidentDynamicsForm.value"
            [involvedVehiclesData]="involvedVehiclesForm.value"
            [crashesInfoData]="crashesInfoData"
            [damageData]="danniForm.value"
            (goToStep)="goToStep($event)"
            (submitSuccess)="onSubmitSuccess($event)">
          </app-step-summary>
          }
        </mat-expansion-panel>
        }
      </mat-accordion>
    </mat-card-content>
  </mat-card>
  }
</div>